var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon32Product(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-32-product",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7069",
    "data-name": "Rectangle 7069",
    width: 32,
    height: 32,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(0 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M5,11.485,9.632,5l4.632,6.485Z",
    transform: "translate(0 -0.193)",
    fill: "none",
    stroke: "#ffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M10,5H21.116l4.632,6.485H14.632",
    transform: "translate(-0.368 -0.193)",
    fill: "none",
    stroke: "#ffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7064",
    "data-name": "Rectangle 7064",
    width: 12,
    height: 4,
    transform: "translate(9.19 0.997)",
    fill: "none",
    stroke: "#ffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7065",
    "data-name": "Rectangle 7065",
    width: 9,
    height: 18,
    transform: "translate(5.19 10.997)",
    fill: "none",
    stroke: "#ffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7066",
    "data-name": "Rectangle 7066",
    width: 11,
    height: 18,
    transform: "translate(14.19 10.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7067",
    "data-name": "Rectangle 7067",
    width: 20,
    height: 5,
    transform: "translate(5.19 10.997)",
    fill: "none",
    stroke: "#ffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7068",
    "data-name": "Rectangle 7068",
    width: 20,
    height: 5,
    transform: "translate(5.19 23.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Product);
export default __webpack_public_path__ + "static/media/icon-32-product.391a93e405d9d4b78b4f24cd834dc71a.svg";
export { ForwardRef as ReactComponent };